import React, { Component } from 'react';
import { compose } from 'recompose';
import { Button, Form, Container, Segment, Dropdown } from 'semantic-ui-react';

import { withFirebase } from '../Firebase';
import { withAuthorization } from '../Session';
import * as ROLES from '../../constants/roles';

const INITIAL_STATE = {
  feedbackID: '111',
  feedbackCustomerName: '',
  feedbackCustomerEmail: '',
  feedbackOutlet: [],
  feedbackDescription: '',
};

class SubmitFeedbackUser extends Component {
  constructor(props) {
    super(props);
 
    this.state = { 
      ...INITIAL_STATE 
    };
  }

  onSubmitFeedback = event => {
    const { feedbackID, feedbackCustomerName, feedbackCustomerEmail, feedbackDescription, feedbackOutlet } = this.state;
    const dateSubmitted = (new Date()).toLocaleString();
    this.props.firebase.doCreateNewFeedback(dateSubmitted, feedbackID, feedbackCustomerName, feedbackCustomerEmail, feedbackDescription, feedbackOutlet);
    this.setState({ ...INITIAL_STATE });
    event.preventDefault();
    window.location.reload(false);
  };

  handleChange = (event, data) => {
    this.setState({
      [data.name]: data.value
    });
  }

  onChangeFeedback = event => {
    this.setState({ [event.target.name]: event.target.value });
  };

  render() {
    const { feedbackID, feedbackCustomerName, feedbackCustomerEmail, feedbackDescription } = this.state;

    const feedbackOutlet = [
      { key: 'sr', value: '1359 Serangoon Road (The Grillery)', text: '1359 Serangoon Road (The Grillery)' },
      { key: 'nb', value: '189 New Bridge Road (Roadside)', text: '189 New Bridge Road (Roadside)'  },
      { key: 'gr', value: '301 Geylang Road (Roadside)', text: '301 Geylang Road (Roadside)' },
      { key: 'amkc', value: 'Ang Mo Kio Central (Roadside)', text: 'Ang Mo Kio Central (Roadside)' },
      { key: 'bm', value: 'Bedok Mall', text: 'Bedok Mall' },
      { key: 'bn', value: 'Bedok North (Roadside)', text: 'Bedok North (Roadside)' },
      { key: 'bv', value: 'Bugis Village', text: 'Bugis Village' },
      { key: 'bpp', value: 'bBukit Panjang Plaza', text: 'Bukit Panjang Plaza' },
      { key: 'cp', value: 'Causeway Point', text: 'Causeway Point' },
      { key: 'te', value: 'Changi Airport Terminal 1, Departure/Transit East', text: 'Changi Airport Terminal 1, Departure/Transit East' },
      { key: 'cih', value: 'Changi Airport Terminal 2, Departure/Check-In Hall (Public Area)', text: 'Changi Airport Terminal 2, Departure/Check-In Hall (Public Area)' },
      { key: 'tn', value: 'Changi Airport Terminal 2, Departure/Transit Lounge North', text: 'Changi Airport Terminal 2, Departure/Transit Lounge North' },
      { key: 'ts', value: 'Changi Airport Terminal 2, Departure/Transit Lounge South', text: 'Changi Airport Terminal 2, Departure/Transit Lounge South' },
      { key: 'cih4', value: 'Changi Airport Terminal 4, Departure/Check-In Hall', text: 'Changi Airport Terminal 4, Departure/Check-In Hall' },
      { key: 'tn4', value: 'Changi Airport Terminal 4, Departure/Transit Lounge North', text: 'Changi Airport Terminal 4, Departure/Transit Lounge North'  },
      { key: 'cc', value: 'Clementi Central (Roadside)', text: 'Clementi Central (Roadside)' },
      { key: 'cm', value: 'Clementi Mall', text: 'Clementi Mall' },
      { key: 'co', value: 'Compass One', text: 'Compass One' },
      { key: 'ecr', value: 'East Coast Road (Roadside)', text: 'East Coast Road (Roadside)' },
      { key: 'gwc', value: 'Great World City', text: 'Great World City' },
      { key: 'hc', value: 'Harbourfront Centre', text: 'Harbourfront Centre' },
      { key: 'hb', value: 'Hotel Boss', text: 'Hotel Boss' },
      { key: 'hm', value: 'Hougang Mall', text: 'Hougang Mall' },
      { key: 'jem', value: 'JEM', text: 'JEM' },
      { key: 'jew', value: 'JEWEL', text: 'JEWEL' },
      { key: 'j8', value: 'Junction 8', text: 'Junction 8' },
      { key: 'jp', value: 'Jurong Point', text: 'Jurong Point' },
      { key: 'l1', value: 'Lot 1 Shopping Mall', text: 'Lot 1 Shopping Mall' },
      { key: 'nex', value: 'NEX', text: 'NEX' },
      { key: 'nc', value: 'Northpoint City', text: 'Northpoint City' },
      { key: 'pag', value: 'Pagoda (Roadside)', text: 'Pagoda (Roadside)' },
      { key: 'par', value: 'Paragon', text: 'Paragon' },
      { key: 'pp', value: 'Parkway Parade', text: 'Parkway Parade' },
      { key: 'plq', value: 'Paya Lebar Quarter', text: 'Paya Lebar Quarter' },
      { key: 'perp', value: 'Peranakan Place', text: 'Peranakan Place' },
      { key: 'rc', value: 'Raffles City Shopping Centre', text: 'Raffles City Shopping Centre' },
      { key: 'rws', value: 'Resorts World Sentosa', text: 'Resorts World Sentosa' },
      { key: 'sa', value: 'Sims Avenue', text: 'Sims Avenue' },
      { key: 'scm', value: 'Suntec City Mall', text: 'Suntec City Mall' },
      { key: 'taka', value: 'Takashimaya', text: 'Takashimaya' },
      { key: 'tc', value: 'Tampines Central', text: 'Tampines Central' },
      { key: 'tm', value: 'Tampines Mall', text: 'Tampines Mall' },
      { key: 'tbp', value: 'Tiong Bahru Plaza', text: 'Tiong Bahru Plaza' },
      { key: 'tpc', value: 'Toa Payoh Central (Roadside)', text: 'Toa Payoh Central (Roadside)' },
      { key: 'vh', value: 'V Hotel', text: 'V Hotel' },
      { key: 'wp', value: 'Waterway Point', text: 'Waterway Point' },
      { key: 'wm', value: 'West Mall', text: 'West Mall' },
      { key: 'ws', value: 'White Sands Shopping Centre', text: 'White Sands Shopping Centre' },
    ]

    const isInvalidFeedback = feedbackCustomerName === '' || feedbackDescription === '' || feedbackOutlet === '';

    return (
      <Container>
      <hr />
          <div class="ui inverted fluid segment">
          <h1>Submit a new Feedback</h1>
          </div>
      <p></p>
      <Segment>
          <Form size="large" onSubmit={this.onSubmitFeedback}>
          <Form.Input
            fluid
            name="feedbackID"
            value={feedbackID}
            onChange={this.onChangeFeedback}
            type="hidden"
            placeholder="Feedback ID"
          />            
          <Form.Input
            fluid
            icon="question circle"
            iconPosition="left"
            name="feedbackCustomerName"
            value={feedbackCustomerName}
            onChange={this.onChangeFeedback}
            type="text"
            placeholder="Feedback Customer Name"
          />
          <Form.Input
            fluid
            icon="question circle"
            iconPosition="left"
            name="feedbackCustomerEmail"
            value={feedbackCustomerEmail}
            onChange={this.onChangeFeedback}
            type="text"
            placeholder="Feedback Customer Email"
          />
          <Form.Input
            fluid
            icon="map marker alternate"
            iconPosition="left"
            name="feedbackDescription"
            value={feedbackDescription}
            onChange={this.onChangeFeedback}
            placeholder="Feedback Description"
            type="text"
          />
        <Dropdown
          fluid
          name="feedbackOutlet"
          search 
          selection 
          options={feedbackOutlet}
          onChange={this.handleChange}
          placeholder="Select an Outlet"
        />

        <p></p>

          <Button disabled={isInvalidFeedback} color="green" fluid size="large" type="submit">Submit a New Feedback by Customer</Button>
        </Form>
      </Segment>
    </Container>
    );
  }
}

const condition = authUser => authUser && !!authUser.isNewUser === false && !!authUser.roles[ROLES.USER];
 
export default compose(
  withAuthorization(condition),
  withFirebase,
)(SubmitFeedbackUser);